import { render, staticRenderFns } from "./formUploadButton.vue?vue&type=template&id=b8cfcb08&"
import script from "./formUploadButton.vue?vue&type=script&lang=js&"
export * from "./formUploadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports